var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-component"},[_c('span',{staticClass:"time",class:_vm.minutes <= 1 ? 'red' : null},[_vm._v(_vm._s(_vm.hoursString)+":"+_vm._s(_vm.minutesString)+":"+_vm._s(_vm.secondsString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }